import uuidv4 from 'uuid/v4';
import ProductScreen from '../screens/ProductScreen';

export const ADD_TO_CART = 'ADD_TO_CART'
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS'

export const TIME_RENEWAL = 'TIME_RENEWAL'
export const TIME_RENEWAL_SUCCESS = 'TIME_RENEWAL_SUCCESS'

export const REMOVE_ITEM_FROM_CART = 'REMOVE_FROM_CART'
export const REMOVE_ITEM_FROM_CART_SUCCESS = 'REMOVE_FROM_CART_SUCCESS'

export const REMOVE_ALL_ITEMS_FROM_CART = 'REMOVE_ALL_ITEMS_FROM_CART'
export const REMOVE_ALL_ITEMS_FROM_CART_SUCCESS = 'REMOVE_ALL_ITEMS_FROM_CART_SUCCESS'

// ------------------------------ Add Item To Cart -----------------------------------------

/**
 * ADD TO CART
 * @param {*} product 
 */
export function addToCart(product, sessionId) {
  return (dispatch) => {
    dispatch(dispatchAddToCart())
    // @TODO Fetch the log in API, call Sign In success or failure

    // if is_bike === false don't call database just add to cart, also create a uuid since we wont get an id back from the database
    if (product.is_bike) { // push to database
      return fetch('/api/postCartItem', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: product.id,
          variant: product.variantName,
          value: product.variantValue,
          sessionId: sessionId,
        })
      })
      .then((res) => res.json())
      .then((row) => {
        console.log(row);
        let cartId = row[0].id;
        dispatch(dispatchAddToCartSuccess(product, cartId));
      })
    }
    else {
      let cartId = uuidv4();
      dispatch(dispatchAddToCartSuccess(product, cartId));
    }
  }
}


function dispatchAddToCart() {
  return {
    type: ADD_TO_CART
  }
}

function dispatchAddToCartSuccess(product, cartId) {
  return {
    type: ADD_TO_CART_SUCCESS,
    cartItemId: cartId, // Returns an array of Id's, however response will only be one add since we add one cart item at a time
    item: product,
    date: new Date()
  }
}

// ----------------------------------- Add An Additional 15 Minutes to the Cart Session -----------------------------

/**
 * INCREMENT SESSION TIME ON THE CART DATABASE
 * @param {*} sessionId 
 */
export function addTimeToCart(sessionId) {
  return (dispatch) => {
    dispatch(dispatchAddTimeToCart())
    return fetch('/api/addCartTime', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sessionId: sessionId,
      })
    })
    .then((res) => res.json())
    .then((row) => {
      console.log(row);
      dispatch(dispatchAddTimeToCartSuccess());
    })
  }
}

function dispatchAddTimeToCart() {
  return {
    type: TIME_RENEWAL
  }
}

function dispatchAddTimeToCartSuccess() {
  return {
    type: TIME_RENEWAL_SUCCESS
  }
}

// ---------------------------- Remove Single Product From Cart ------------------------------------------

/**
 * REMOVE INDIVIDUAL ITEM FROM CART
 * @param {*} product 
 */
export function removeItemFromCart(product) {
  return (dispatch) => {
    dispatch(dispatchRemoveItemFromCart())
    return fetch('/api/deleteCartItem', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: product.cartItemId,
      })
    })
    .then((res) => res.json())
    .then((row) => {
      console.log(row);
      dispatch(dispatchRemoveItemFromCartSuccess(product));
    })
  }
}

function dispatchRemoveItemFromCart() {
  return {
    type: REMOVE_ITEM_FROM_CART
  }
}

function dispatchRemoveItemFromCartSuccess(product) {
  return {
    type: REMOVE_ITEM_FROM_CART_SUCCESS,
    cartItemId: product.cartItemId, // use this uniqueItemId to remove from cart
    price: product.price ? product.price : 0
  }
}

// --------------------------------- Remove All Items From Cart Using Session ID --------------------------------

/**
 * REMOVE ALL SESSION ITEMS FROM CART
 * @param {*} sessionId 
 */
export function removeAllItemsFromCart(sessionId) {
  return (dispatch) => {
    dispatch(dispatchRemoveAllItemsFromCart())
    return fetch('/api/deleteAllSessionCart', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sessionId: sessionId,
      })
    })
    .then((res) => res.json())
    .then((row) => {
      console.log(row);
      dispatch(dispatchRemoveAllItemsFromCartSuccess());
    })
  }
}

function dispatchRemoveAllItemsFromCart() {
  return {
    type: REMOVE_ALL_ITEMS_FROM_CART
  }
}

function dispatchRemoveAllItemsFromCartSuccess() {
  return {
    type: REMOVE_ALL_ITEMS_FROM_CART_SUCCESS
  }
}
